/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { VivaLiteScanStrictHttpResponse } from '../../viva-lite-scan-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { VisionTrainingFlagsModel } from '../../models/vision-training-flags-model';

export interface AdminOrganizationOrganizationIdVisionFlagsGet$Params {
  organizationId: string;
}

export function adminOrganizationOrganizationIdVisionFlagsGet(http: HttpClient, rootUrl: string, params: AdminOrganizationOrganizationIdVisionFlagsGet$Params, context?: HttpContext): Observable<VivaLiteScanStrictHttpResponse<VisionTrainingFlagsModel>> {
  const rb = new RequestBuilder(rootUrl, adminOrganizationOrganizationIdVisionFlagsGet.PATH, 'get');
  if (params) {
    rb.path('organizationId', params.organizationId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as VivaLiteScanStrictHttpResponse<VisionTrainingFlagsModel>;
    })
  );
}

adminOrganizationOrganizationIdVisionFlagsGet.PATH = '/Admin/Organization/{organizationId}/VisionFlags';
